import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { AnimatedList } from 'react-animated-list';

import Placeholder from 'components/Placeholder';

import {
  Card,
  CardContent,
  ListingHeader,
  Listing,
  ListingItem,
  ApplicationValue,
} from 'components/Listing/styles';

import { Wrapper } from 'components/ApplicationIcon/styles';
import { Acesso, AcessosList } from 'components/Acessos';

const DomainPlaceholder = () => {
  const placeholders = [];

  for (let i = 1; i <= 4; i++) {
    placeholders.push(i);
  }

  return (
    <>
      <ListingHeader>
        <Row>
          <Col xs="10" sm="10" md="6" lg="5" xl="5">
            <Wrapper>
              <p>Domínio</p>
            </Wrapper>
          </Col>

          <Col className="d-none d-sm-none d-md-flex">
            <p>Atualizado em</p>
          </Col>

          <Col xl="2" className="d-none d-xl-flex" />
        </Row>
      </ListingHeader>

      <Listing>
        <AnimatedList initialAnimationDuration={800} animation="grow">
          {placeholders.map((p, i) => (
            <ListingItem key={p} fade={i > 0 && i}>
              <Card>
                <CardContent>
                  <Col xs="10" sm="10" md="6" lg="5" xl="5">
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 15,
                      }}
                    >
                      <Placeholder circle width={40} height={40} />
                      <span style={{ marginLeft: 12 }}>
                        <Placeholder width={150} height={12} />
                      </span>
                    </div>
                  </Col>

                  <Col md xl className="d-none d-sm-none d-md-flex">
                    <ApplicationValue>
                      <Placeholder width={50} height={8} />
                    </ApplicationValue>
                  </Col>

                  <Col xl="2" className="d-none d-xl-flex">
                    <AcessosList>
                      <Acesso active hover>
                        <Placeholder width={16} height={18} />
                      </Acesso>

                      <Acesso active hover>
                        <Placeholder width={16} height={18} />
                      </Acesso>

                      <Acesso active hover>
                        <Placeholder width={16} height={18} />
                      </Acesso>

                      <Acesso active hover>
                        <Placeholder width={16} height={18} />
                      </Acesso>
                    </AcessosList>
                  </Col>
                </CardContent>
              </Card>
            </ListingItem>
          ))}
        </AnimatedList>
      </Listing>
    </>
  );
};

export default DomainPlaceholder;
